import style from "../CSS/RoundVideoResult.module.css";

const SubTitle = ({subTitle}) => {
    return (
        <>
            <div className={style.sub__title}>
                <h6>{subTitle}</h6>
                <hr/>
            </div>
        </>
    );
};

export default SubTitle;